<template>
  <v-card color="grey lighten-4">
    <v-card-title primary-title>
      <div>
        <div class="headline">
          <v-icon>mdi-account</v-icon> {{ user.username }}
        </div>
        <div class="grey--text caption">
          Last login: {{ user.last_login }}
        </div>
        <br>
        <v-chip
          label
          outlined
          class="grey--text lighten-2"
        >
          <template v-if="type === 'dataset'">
            {{ permissionsDataset.find(el => user.perms.includes(el.value)).text }}
          </template>
          <template v-else-if="type === 'api'">
            {{ permissionsApi.find(el => user.perms.includes(el.value)).text }}
          </template>
          <template v-else-if="type === 'function'">
            {{ permissionsFunction.find(el => user.perms.includes(el.value)).text }}
          </template>
          <template v-else-if="type === 'project'">
            {{ permissionsProject.find(el => user.perms.includes(el.value)).text }}
          </template>
        </v-chip>
      </div>
    </v-card-title>
    <v-card-actions>
      <v-spacer />
      <template v-if="userPermissions.includes('owner_dataset') && type === 'dataset' || userPermissions.includes('owner_api') && type === 'api' || userPermissions.includes('owner_function') && type === 'function'">
        <v-menu
          v-model="menu"
          offset-x
          :close-on-content-click="false"
          :nudge-width="200"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
            >
              <v-icon color="grey darken-1">
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <v-list-item-title avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ user.username }}</v-list-item-title>
                  <v-list-item-sub-title>Last login: {{ user.last_login }}</v-list-item-sub-title>
                </v-list-item-content>
              </v-list-item-title>
            </v-list>
            <v-divider />
            <v-list>
              <v-list-item-title v-if="type === 'dataset'">
                <v-btn
                  v-for="role in permissionsDataset"
                  :key="role.value"
                  :color="(selectedPermission===role.value) ? 'secondary' : ''"
                  @click.native="selectedPermission=role.value"
                >
                  {{ role.text }}
                </v-btn>
              </v-list-item-title>
              <v-list-item-title v-if="type === 'api'">
                <v-btn
                  v-for="role in permissionsApi"
                  :key="role.value"
                  :color="(selectedPermission===role.value) ? 'secondary' : ''"
                  @click.native="selectedPermission=role.value"
                >
                  {{ role.text }}
                </v-btn>
              </v-list-item-title>
              <v-list-item-title v-if="type === 'function'">
                <v-btn
                  v-for="role in permissionsFunction"
                  :key="role.value"
                  :color="(selectedPermission===role.value) ? 'secondary' : ''"
                  @click.native="selectedPermission=role.value"
                >
                  {{ role.text }}
                </v-btn>
              </v-list-item-title>
              <v-list-item-title v-if="type === 'project'">
                <v-btn
                  v-for="role in permissionsProject"
                  :key="role.value"
                  :color="(selectedPermission===role.value) ? 'secondary' : ''"
                  @click.native="selectedPermission=role.value"
                >
                  {{ role.text }}
                </v-btn>
              </v-list-item-title>
            </v-list>
            <v-card-actions>
              <v-spacer />
              <v-btn
                text
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                text
                @click.native="changePermission(user, [selectedPermission], type)"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <template>
          <v-dialog
            v-model="deleteDialog"
            persistent
            max-width="400px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon color="grey darken-1">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">
                Delete this user's permissions
              </v-card-title>
              <v-card-text>Are you sure you want to delete this user's permissions?</v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color=""
                  text
                  @click.native="deleteDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click.native="deletePermission(user, type)"
                >
                  Delete
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
  import DatasetService from '../../Dashboard/Views/Datastore/services/DatasetService'
  import ApiService from '../../Dashboard/Views/Apis/services/ApiService'
  import FunctionService from '../../Dashboard/Views/Functions/services/FunctionService'
  import ProjectService from '../../Dashboard/Views/Projects/services/ProjectService'

  export default {
    props: {
      user: {},
      dataset: {},
      api: {},
      hmdFunction: {},
      project: {},
      type: null,
      index: Number,
      userPermissions: null,

    },
    data () {
      return {
        fav: true,
        menu: false,
        message: false,
        hints: true,
        permissionsDataset: [
          { text: 'Can manage', value: 'owner_dataset' },
          { text: 'Can edit', value: 'read_write_dataset' },
          { text: 'Can view', value: 'read_dataset' },
        ],
        permissionsApi: [
          { text: 'Can manage', value: 'owner_api' },
          { text: 'Can edit', value: 'read_write_api' },
          { text: 'Can view', value: 'read_api' },
        ],
        permissionsFunction: [
          { text: 'Can manage', value: 'owner_function' },
          { text: 'Can execute', value: 'execute_function' },
          { text: 'Can read', value: 'read_function' },
        ],
        permissionsProject: [
          { text: 'Can manage', value: 'owner_project' },
          { text: 'Can edit', value: 'read_write_project' },
          { text: 'Can view', value: 'read_project' },
        ],
        deleteDialog: false,
        selectedPermission: null,
      }
    },
    methods: {
      deletePermission (user, type) {
        this.deleteDialog = false
        if (type === 'dataset') {
          DatasetService.deletePermission(this, this.dataset, user)
        } else if (type === 'api') {
          ApiService.deletePermission(this, this.api, user)
        } else if (type === 'function') {
          FunctionService.deletePermission(this, this.hmdFunction, user)
        } else if (type === 'project') {
          ProjectService.deletePermission(this, this.project, user)
        }
      },
      changePermission (user, permission, type) {
        this.menu = false
        if (type === 'dataset') {
          DatasetService.changePermission(this, this.dataset, user.username, permission)
        } else if (type === 'api') {
          ApiService.changePermission(this, this.api, user.username, permission)
        } else if (type === 'function') {
          FunctionService.changePermission(this, this.hmdFunction, user.username, permission)
        } else if (type === 'project') {
          ProjectService.changePermission(this, this.project, user.username, permission)
        }
      },
    },

  }
</script>
